// components/PdfContent.js
import React from 'react';
import { Box, Divider, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import PdfLayout from '../../components/pdfLayout';

export default function PdfPaymentInvoice({ data, refunded }) {
    return (
        <PdfLayout data={data}>
            <Box sx={{ p: 3, fontFamily: 'Arial, sans-serif', backgroundColor: '#fff' }}>
                <Typography variant="body1">To</Typography>
                <Typography variant="body1">{data?.investorName }</Typography>

                {
                    refunded ?
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            We are pleased to inform you that your refund of <strong>₹{data?.amountTransferred?.toLocaleString('en-IN')}</strong> has been successfully processed by RealX against your investment in <strong>{data?.propertyName}</strong>
                        </Typography> :
                        <Typography variant="body1" sx={{ mt: 2 }}>
                            We are pleased to confirm that your  payment of <strong>₹{data?.totalAmountPaid?.toLocaleString('en-IN')}</strong> has been successfully received by RealX against your investment commitment towards <strong>{data?.propertyName}</strong>
                        </Typography>
                }

                <TableContainer sx={{ mt: 2 }}>
                    <Typography variant="h6" sx={{ p: 2 }}>Transaction Summary</Typography>
                    <Table sx={{ border: '1px solid #e1e1e1', borderCollapse: 'collapse' }}>
                        <TableBody>
                            <TableRow>
                                <TableCell><strong>{refunded ? "Amount Refunded" : "Amount Paid"}</strong></TableCell>
                                <TableCell><strong>₹{refunded ? data?.amountTransferred?.toLocaleString('en-IN') || '0' : data?.amountByAdmin?.toLocaleString('en-IN') || '0'}</strong></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>{refunded ? "Refund Date" : "Payment Date"}</strong></TableCell>
                                <TableCell><strong>{data?.updated_at || 'N/A'}</strong></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>Approved Date</strong></TableCell>
                                <TableCell><strong>{data?.actionTaken || 'N/A'}</strong></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell><strong>UTR</strong></TableCell>
                                <TableCell><strong>{data?.refId || 'N/A'}</strong></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <Typography sx={{ mt: 2 }}>Regards,</Typography>
                <Typography>Team RealX</Typography>
            </Box>
        </PdfLayout>
    );
}
